module.exports = __webpack_public_path__ + "static/img/weibo.e43ecf7b.png";